import { EnqueteStatus } from "@lu/muscat-library";
import { Decoder, union, constant } from "@lu/typed-json";

export const statusDecoder: Decoder<EnqueteStatus> = union(
	constant("complete"),
	constant("debug"),
	constant("progress"),
	constant("stopping")
);
